export default "__VITE_ASSET__f5e33efb__"